'use strict';

angular.module('ecrd.core')
    .provider('CoreRecordMetadata', function() {
        this.$get = ['CoreRecord', function CoreRecordMetadata(CoreRecord) {
            return CoreRecord.getMetadata();
        }];
    });
